var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_562",
    "data-name": "Group 562",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12706",
    "data-name": "Path 12706",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12707",
    "data-name": "Path 12707",
    d: "M14.32,25.24A10.92,10.92,0,1,1,25.24,14.32,10.932,10.932,0,0,1,14.32,25.24m0-20.3A9.378,9.378,0,1,0,23.7,14.32,9.389,9.389,0,0,0,14.32,4.942",
    transform: "translate(0.68 0.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12708",
    "data-name": "Path 12708",
    d: "M17.769,10.914l-3.157,2.431a1.879,1.879,0,0,1,.047.414,1.85,1.85,0,1,1-2.621-1.682v-5.1a.771.771,0,1,1,1.542,0v5.218l.092-.071,3.157-2.43a.771.771,0,0,1,.94,1.222",
    transform: "translate(2.192 1.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12709",
    "data-name": "Path 12709",
    d: "M13.235,11.144l-.092.071V11.1c.031.014.062.03.092.047",
    transform: "translate(2.629 2.219)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.9275e471138f377096c74f42df7737fa.svg";
export { ForwardRef as ReactComponent };